// 短信营销路由
export default {
    path: 'smsMarketing',
	name: 'smsMarketing',
    component: () => import('@/components/RouterView'),
    redirect: '/manage/smsmarketing/home',
    meta: {title: '短信营销'},    
	children: [{
	    path: 'home',
	    name: 'home',
	    component: () => import('@/views/manage/smsMarketing/home'),
	    meta: {title: '首页'},
	},{
	    path: 'send',
	    name: 'send',
	    component: () => import('@/views/manage/smsMarketing/send'),
	    meta: {title: '发送短信列表',showTitle:false},
	},{
        path:'send/add',
        component: () => import('@/views/manage/smsMarketing/send/add'),
        meta: {title: '发送短信'}, 
		props:true,
    },{
        path:'send/edit/:id',
        component: () => import('@/views/manage/smsMarketing/send/add'),
        meta: {title: '编辑短信',showTitle:false},
        props:true
    },{
        path:'send/data/:id',
        component: () => import('@/views/manage/smsMarketing/send/data'),
        meta: {title: '短信数据',showTitle:false}, 
		props:true,
    },{
	    path: 'cost',
	    name: 'cost',
	    component: () => import('@/views/manage/smsMarketing/cost'),
	    meta: {title: '计费明细'},
	}]
}